import { useMemo } from "react";
import { Store } from "lucide-react";

const CATEGORY_COLORS = {
  Security: "#00F0FF", Finance: "#00FF66", Productivity: "#FFD700",
  Gaming: "#FF2A2A", General: "#8b9bd4", Social: "#c07bff", Tools: "#00F0FF",
};

export function AppIcon({ name, size = 56, category = "General", src }) {
  const initials = useMemo(() => {
    const parts = (name || "?").trim().split(/\s+/);
    return (parts[0]?.[0] || "") + (parts[1]?.[0] || "");
  }, [name]);
  const color = CATEGORY_COLORS[category] || "#00F0FF";

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className="object-cover border shrink-0"
        style={{ width: size, height: size, borderColor: `${color}55`, boxShadow: `inset 0 0 14px ${color}22` }}
      />
    );
  }

  return (
    <div
      className="flex items-center justify-center border font-display font-bold shrink-0"
      style={{
        width: size, height: size,
        borderColor: `${color}55`,
        color,
        background: `linear-gradient(135deg, ${color}18, transparent)`,
        boxShadow: `inset 0 0 14px ${color}22`,
        fontSize: size * 0.32,
      }}
    >
      {initials ? initials.toUpperCase() : <Store className="w-6 h-6" />}
    </div>
  );
}
